<template>
  <!-- <div class="clearfix"  v-if="!pageLoad">
      <div class="spinner-grow text-danger " style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
  </div> -->
  <!-- v-if="pageLoad" -->
  <!-- <div  class="row justify-content-center"  style="margin-top:-8%"> -->
  <div class="row mx-auto mt-1" style="">
    <div class="col-12 col-md-8 col-lg-6 col-xl-7 col-xxl-6 col-xxxl-4">
      <div class="card mb-25 border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing row">
          <div class="col-12">
              <div class="row"  v-if="step0 == 0">
                <div class="col-12">
                  <!-- step 0 -->
                  <div v-if="step0 == 0 && status == 'SUCCEEDED'" class="form-group mb-15 mb-sm-20 mb-md-25">
                    <h2 class="text-center"><i class="flaticon-secure-shield" style="color:green;"></i></h2>
                    <h3 class="text-center">Votre paiement a été approuvé</h3>
                  </div>
                  <div v-if="step0 == 0 && status == 'FAILED'" class="form-group mb-15 mb-sm-20 mb-md-25">
                    <h2 class="text-center"><i class="flaticon-cancel" style="color:red;"></i></h2>
                    <h2 class="text-center">Votre paiement a échoué</h2>
                  </div>
                  <div v-if="step0 == 0 && (status == 'PROCESSING' || status == 'PENDING')" class="form-group mb-15 mb-sm-20 mb-md-25">
                    <h2 class="text-center"><i class="flaticon-compare" style="color:blue;"></i></h2>
                    <h2 class="text-center">Votre paiement est en cours</h2>
                  </div>
                  <div v-if="step0 == 0 && status != 'SUCCEEDED'"
                    class="row line-numbers bg-gray pt-0 pb-0 ps-25 pe-25 mb-0">
                    <p><span class="text-black fw-bold">Opérateur : </span><span>{{ selectedOperator }}</span></p>
                    <p><span class="text-black fw-bold">ID Transaction : </span><span>{{ checkoutId }}</span></p>
                    <p><span class="text-black fw-bold">Date Paiement : </span><span>{{ formatDateFr(new Date())
                    }}</span></p>
                  </div>
                  <!-- && status=='SUCCEEDED' -->
                  <div v-if="step0 == 0 && status == 'SUCCEEDED'" class="form-group mb-15 mb-sm-20 mb-md-25">
                    <button @click="download_receipt"
                      class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 border border-warning"
                      style="background-color: #fff;border-color:#EB9355;border-width:1px;border-style: solid;">

                      <!-- <i class="flaticon-chevron-1 mt-2"  style = "color:#EB9355;"></i>       -->
                      <span class="align-baseline" style="color:#EB9355">Télécharger le réçu</span>
                    </button>
                  </div>
                  <!--step3==1 && status=='SUCCEEDED' -->
                  <div ref="PDFReceipt" v-if="step0 == 0 && status == 'SUCCEEDED'" id="receipt"
                    class="form-group mb-15 mb-sm-20 mb-md-25 PDFReceipt d-none">
                    <div id="header_receipt">
                      <h2 style="padding:2% 5% 2% 5%;color: #fff;">
                        <span>
                          <img src="../../../assets/images/i-money1.jpg" alt="logo-icon" style="max-width:10%;" />
                          <span class="logo_text">IZYPAY</span>
                        </span>
                        <span id="header_text">
                          REÇU DE TRANSACTION
                        </span>
                      </h2>
                    </div>
                    <div id="body_receipt">
                      <div id="arrow-top-section">
                        <span id="arrow-top-left" class="section_content"><img
                            src="../../../assets/images/arrowtopleft.svg" alt="logo-icon"
                            style="min-width:3%;" /></span>
                        <span id="arrow-top-right" class="section_content"><img
                            src="../../../assets/images/arrowtopright.svg" alt="logo-icon"
                            style="min-width:3%;" /></span>
                      </div>
                      <div id="body_first_section">
                        <p v-if="name != ''"><span class="section_label">BENEFICIAIRE</span>&nbsp;:&nbsp;<span
                            class="section_content">{{ name }}</span></p>
                        <p><span class="section_label">OPERATEUR</span>&nbsp;:&nbsp;<span class="section_content">{{
                          selectedOperator }}</span></p>
                        <p><span class="section_label">TELEPHONE</span>&nbsp;:&nbsp;<span class="section_content">{{
                          phone }}</span></p>
                        <p><span class="section_label">DATE</span>&nbsp;:&nbsp;<span class="section_content">{{
                          formatDateFr(new Date()) }}</span></p>
                        <p style="margin-top: 10%;"><span class="section_label">CODE DE TRANSACTION</span><span
                            class="section_content_other">{{ checkoutId }}</span></p>
                      </div>
                      <div id="body_second_section">
                        <p><span class="section_label">MONTANT...................................... </span><span
                            class="section_content_other1">{{ amount }} F</span></p>
                        <p v-if="status === 'FAILED'"><span
                            class="section_label">STATUT........................................... </span><span
                            class="section_content_other1">ECHEC&nbsp;<img src="../../../assets/images/check.svg"
                              alt="logo-icon" style="max-width:25%;" /></span></p>
                        <p v-if="status === 'SUCCEEDED'"><span
                            class="section_label">STATUT........................................... </span><span
                            class="section_content_other1">SUCCÈS&nbsp;<img src="../../../assets/images/check.svg"
                              alt="logo-icon" style="max-width:25%;" /></span></p>
                        <p v-if="status === 'PROCESSING'"><span
                            class="section_label">STATUT........................................... </span><span
                            class="section_content_other1">EN COURS&nbsp;<img src="../../../assets/images/check.svg"
                              alt="logo-icon" style="max-width:25%;" /></span></p>
                      </div>
                      <div id="body_third_section">
                        <p><span class="section_label">MERCI POUR LA CONFIANCE !</span>&nbsp;&nbsp;<span
                            class="section_content"><img src="../../../assets/images/imoji.svg" alt="logo-icon"
                              style="max-width:25%;" /></span></p>
                      </div>
                      <div id="arrow-bottom-section">
                        <span id="arrow-bottom-left" class="section_content"><img
                            src="../../../assets/images/arrowbottomleft.svg" alt="logo-icon"
                            style="min-width:3%;" /></span>
                        <span id="arrow-bottom-right" class="section_content"><img
                            src="../../../assets/images/arrowbottomright.svg" alt="logo-icon"
                            style="min-width:3%;" /></span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import router from '@/router';
import { useRoute } from 'vue-router'
import axios from 'axios';
import { ref, reactive, inject, onMounted } from 'vue';
import html2pdf from "html2pdf.js";
import 'vue-tel-input/vue-tel-input.css';

import { Country, Fee, Operator } from "@/utils/Model";

import { validate_phone_number, formatDateFr } from "../../../utils/function";
const backApi = inject('back');
const error = ref('');
const errors = ref('');
const errorId = ref('');
const success = ref('');
const name = ref('');
//const errorsBis = { 'otp': "", 'amount': 0 };//'name':'',
const phone = ref("");
const operators = ref(new Array<Operator>());
let operatorsTemp = new Array<Operator>();

let token: string | null = localStorage.getItem('login_token');
let environment = process.env.VUE_APP_TEST
const selectedOperator = ref('');
if (process.env.VUE_APP_TEST == 'DEMO') {
  selectedOperator.value = 'WAVE';
}

// let contrycode = '';
// let contryIndicatif = ''
const step0 = ref(0);
const step1 = ref(1);
const step2 = ref(0);
const step3 = ref(0);
let checkoutId = "";
let publicToken: string | null = '';
const amount = ref(0);
const status = ref(null);
// let countRetry = 0;
// let linkGenerated = false;
// let verify_transact;
// let sampleInterval;
// const btnLoad = ref(true);
// const pageLoad = ref(false);
// let startingMinutes = ref(5);
// let startingSeconds = ref(0);
// const mins = ref(startingMinutes);
// const secs = ref(startingSeconds);


const goback = () => {
  step1.value = 1;
  step2.value = 0;
  step3.value = 0;
  router.go(0)
}



const showPublicTransaction = (token) => {

  axios.get(backApi + '/public/transactions/' + token, {  //secure
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => {
      if (response.status == 200) {
        amount.value = response.data.amount;  //.data.users   
        status.value = response.data.paymentStatus;
         //console.log("response.data", response.data);
         if(response.data.operationType == "1"){
          checkoutId = response.data.checkoutId;
         }else{
          checkoutId = response.data.payoutId;
         }
        selectedOperator.value = response.data.operator?.mnoName || '';
        phone.value = response.data.contact

      }

    }).catch((error) => {
      if (error.response) {
        // console.log(error.response.data); // => the response payload 
        if (error.response) {
          // errorId.value=error.response.data.errorId;            
          // errors.value=error.response.data.message;  
          // errorId.value=error.response.data.errorId;            
          errors.value = error.response.data;
          router.push('/');
        }

      }
    });
  //  loader.value=true;
}


const PDFReceipt = ref<HTMLElement | null>(null);

const download_receipt = () => {
  //searchTransactionExportToPDF()
  // jQuery.event.trigger({ type: 'keydown', which: 77 });
  var event; // The custom event that will be created
  // if(document.createEvent){
  //     event = document.createEvent("HTMLEvents");
  //     event.initEvent("dataavailable", true, true);
  //     event.eventName = "dataavailable";
  //     element.dispatchEvent(event);
  // } 
  //else {
  //     event = document.createEventObject();
  //     event.eventName = "dataavailable";
  //     event.eventType = "dataavailable";
  //     element.fireEvent("on" + event.eventType, event);
  // }
  
  const element = PDFReceipt.value;
  element.classList.remove("d-none");

  setTimeout(() => {

    document.getElementById("receipt").style.display = 'block';
    
    // document.getElementById("receipt").style.border = 'none';

    // // document.getElementById("receipt").style.visibility='hidden';
    const opt = {
      margin: [0, 0, 0, 0], filename: "receipt_" + publicToken + ".pdf", jsPDF: { unit: 'mm', format: 'a5', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" }, image: { type: 'jpeg', quality: 0.98 },

      html2canvas: { scale: 2 },
    }
    html2pdf().set(opt).from(document.getElementById("receipt")).toPdf().save()
    // html2pdf().set(opt).from(document.getElementById("receipt")).toPdf().get('pdf').then(function (pdf) {      
    //   window.open(pdf.output('bloburl'), '_blank');
    //   document.getElementById("receipt").style.display='none';
    // });

  }, 3000);
  document.getElementById("receipt").style.border = ' 1px solid #706F6F';
}

onMounted(() => {
  const route = useRoute();
  publicToken = route.params.token as string;
  
  showPublicTransaction(publicToken)

});
</script>
<style scoped>
#compte_a_rebours {
  color: black;
  font-size: 450%;
  font-weight: 'bold';
}

.field {
  height: 30px;
}

.selectfield {
  height: 45px;
}

/* rule for A4 */
/* #receipt{
  margin-top: 5px;
}
#header_receipt{
  margin-top: -1%;
  background-color: #871728;
}
#logo_text{
  font-family: gruppo;
}
#header_text{
  font-size: 100%;
  float: inline-end;
  margin-top: 2%;
}
#body_receipt{
  display: flex;
  flex-direction: column;
  padding-top: 15%;
}
#body_first_section{
  margin-left: 20%;
  margin-right: 20%;
  border: 1px solid #706F6F ;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
#body_second_section{
  margin-top:5%;
  margin-left: 20%;
  margin-right: 20%;
  border: 1px solid #706F6F ;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
#body_third_section{
  margin-top:5%;
  margin-left: 20%;
  margin-right: 20%;
  border: 1px solid #706F6F ;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
.section_label{
  font-size: 100%;
  font-weight: bold;
}
.section_content_other{
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  margin-left: 10%;
  padding: 5px 15px 5px 15px;
}
.section_content_other1{
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
} */
/* end rule for A4 */

/* rule for A5 */

.PDFReceipt.d-none {
  display: block !important;
  visibility: hidden;
}

#receipt {
  margin-top: 5px;
  border: 1px solid #706F6F;
  display: flex;
  flex-direction: column;
  width: 148mm;
  /* display: none;   */
  /* add responsive */
  width: 100%;
}

#header_receipt {
  margin-top: -1%;
  background-color: #871728;
}

#logo_text {
  font-family: gruppo;
}

#header_text {
  font-size: 70%;
  float: inline-end;
  margin-top: 3%;
  /* margin-left: 10%; */
}

#arrow-top-section {
  /* display: flex; */
  /* flex-direction: row; */
}

#arrow-top-left {
  /* float: inline-start; */
  margin-left: 12%
}

#arrow-top-right {
  /* float: inline-end; */
  margin-left: 70%
}

#arrow-bottom-left {
  /* float: inline-start; */
  margin-left: 12%
}

#arrow-bottom-right {
  /* float: inline-end; */
  margin-left: 70%
}

#body_receipt {
  display: flex;
  flex-direction: column;
  padding-top: 15%;

  /* add responsive */
  width: 100%; 
}

#body_first_section {
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

#body_second_section {
  margin-top: 5%;
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

#body_third_section {
  margin-top: 5%;
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

.section_label {
  font-size: 100%;
  font-weight: bold;
}

.section_content_other {
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  margin-left: 10%;
  padding: 5px 15px 5px 15px;
}

.section_content_other1 {
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  /* margin-left: 10%; */
  padding: 5px 15px 5px 15px;
}

/* end rule for A5 */
/* Styles pour la liste des opérateurs sur tablette et PC */

@media (min-width: 768px) {
  .authentication-card {
    width: 52rem;
  }

}

/* Styles pour la liste des opérateurs sur smartphones */
.iti .iti--allow-dropdown .iti--show-flags {
  width: 100%;
}

.operator-img, .operator-img_div {
  width: 50px !important;
  height: 50px !important;
}

.operators-list {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: center;
  align-items: center; */
  gap: 10px;
}

.operator-logo {
  cursor: pointer;
  transition: transform 0.2s, opacity 0.2s;
  flex-shrink: 0;
}

.operator-logo:hover {
  transform: scale(1.1);
  opacity: 0.8;
}

/* Media queries pour smartphones */
@media (max-width: 575.98px) {
  .authentication-card {
    width: 20rem !important;
  }
  .operators-list {
    gap: 8px;
    padding: 0 10px;
  }

  .operator-logo {
    width: 40px !important;
    height: 40px !important;
    max-width: 40px !important;
    max-height: 40px !important;
  }
}

@media (max-width: 400px) {
  .operators-list {
    gap: 6px;
    padding: 0 5px;
  }

  .operator-logo {
    width: 35px !important;
    height: 35px !important;
    max-width: 35px !important;
    max-height: 35px !important;
  }
}

@media (max-width: 360px) {
  .authentication-card {
    width: 20rem !important;
  }
  .operators-list {
    gap: 5px;
    padding: 0;
  }

  .operator-logo {
    width: 30px !important;
    height: 30px !important;
    max-width: 30px !important;
    max-height: 30px !important;
  }
}
</style>
